import React from 'react';

const customerData = [
    {
        priority: 'High',
        target: 'VIP Customers',
        action: 'Implement loyalty program and personalized communication',
        segments: ['Champion', 'Potential Loyalist'],
        potential_impact: 'Protect 79.8% of revenue',
    },
    {
        priority: 'Medium',
        target: 'Growth Potential Customers',
        action: 'Increase purchase frequency through targeted promotions',
        segments: [
            'Lost',
            'Champion',
            'Potential Loyalist',
            'At Risk',
            "Can't Lose Them",
            'Other',
            'Promising',
        ],
        potential_impact: 'Grow revenue from 3580 customers',
    },
];

const priorityColor = {
    High: 'bg-red-100 text-red-700',
    Medium: 'bg-yellow-100 text-yellow-700',
    Low: 'bg-green-100 text-green-700',
};

const CustomerCards = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6   min-h-screen">
            {customerData.map((item, idx) => (
                <div key={idx} className="  rounded-2xl shadow-md p-6 hover:shadow-lg transition-all">
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-white">{item.target}</h2>
                        <span
                            className={`text-sm px-3 py-1 rounded-full font-medium ${priorityColor[item.priority] || 'bg-gray-100 text-gray-700'
                                }`}
                        >
                            {item.priority} Priority
                        </span>
                    </div>
                    <p className="text-gray-600 mb-3 dark:text-white">
                        🎯 <strong>Action:</strong> {item.action}
                    </p>
                    <p className="text-gray-600 mb-3 dark:text-white">
                        📊 <strong>Segments:</strong> {item.segments.join(', ')}
                    </p>
                    <p className="text-blue-600 font-semibold">📈 Potential Impact: {item.potential_impact}</p>
                </div>
            ))}
        </div>
    );
};

export default CustomerCards;
